import { render } from "./PlatformLogos.vue?vue&type=template&id=439cc86c&scoped=true"
import script from "./PlatformLogos.vue?vue&type=script&lang=js"
export * from "./PlatformLogos.vue?vue&type=script&lang=js"

import "./PlatformLogos.vue?vue&type=style&index=0&id=439cc86c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439cc86c"]])

export default __exports__